import type { RefreshResult } from '../types.js';

export class RefreshCoordinator {
  private readonly inflight = new Map<string, Promise<RefreshResult>>();

  async refreshOnce(
    key: string,
    refresh: () => Promise<RefreshResult>,
  ): Promise<RefreshResult> {
    const existing = this.inflight.get(key);
    if (existing) return existing;

    const promise = refresh().finally(() => {
      this.inflight.delete(key);
    });

    this.inflight.set(key, promise);
    return promise;
  }
}

export function createRefreshCoordinator(): RefreshCoordinator {
  return new RefreshCoordinator();
}
